import React from 'react';

import { DAY_MONTH_YEAR_HOURS, OrderTypes } from '@/constants';
import { TableV2 } from '@/elements';
import { getFormattedDate } from '@/utils/getFormattedDate.js';

export const MonitoringObjectsTable = ({
  data,
  onPageChange,
  queryParams,
  totalPages,
  totalCount,
  onSortingChange,
  loading,
  onFiltersChange,
}) => {
  const sortingInitial = {
    id: queryParams.sortKey || '',
    desc: queryParams.sortDirection === OrderTypes.Desc,
  };

  const columns = [
    {
      minWidth: 110,
      width: 110,
      enableSorting: true,
      header: 'ID',
      enableColumnFilter: true,
      id: 'id',
      body: 'id',
    },
    {
      header: 'Client name',
      id: 'name',
      enableColumnFilter: true,
      body: 'name',
      minWidth: 200,
    },
    {
      header: 'FlowCollector MO name',
      id: 'monitoringObjectName',
      enableColumnFilter: true,
      body: 'monitoringObjectName',
      minWidth: 200,
    },
    {
      header: 'Description',
      id: 'description',
      body: 'description',
      minWidth: 260,
    },
    {
      header: 'Destination IP',
      id: 'ips',
      minWidth: 260,
      body: ({ getValue }) => {
        const ips = getValue();
        return Array.isArray(ips)
          ? ips.map((ip, index) => (
              <React.Fragment key={index}>
                {ip}

                {index < ips.length - 1 && <br />}
              </React.Fragment>
            ))
          : ips;
      },
    },
    {
      header: 'Account ID',
      id: 'partnerClientAccountId',
      body: 'partnerClientAccountId',
      enableColumnFilter: true,
      minWidth: 110,
    },
    {
      enableSorting: true,
      header: 'Created at',
      id: 'createdAt',
      body: ({ getValue }) => getFormattedDate(getValue(), DAY_MONTH_YEAR_HOURS),
      minWidth: 160,
    },
  ];

  return (
    <div>
      <TableV2
        loading={loading}
        data={data}
        columns={columns}
        page={queryParams.page}
        size={queryParams.pageSize}
        totalPages={totalPages}
        totalCount={totalCount}
        onPageChange={onPageChange}
        onSortingChange={onSortingChange}
        initialStateSort={sortingInitial}
        onFiltersChange={onFiltersChange}
      />
    </div>
  );
};
